import { match } from 'ts-pattern'

import AppHeader from './app-header'
import WebHeader from './web-header'

import { useAppSelector } from '~/app/hooks'
import { constant } from '~/shared/utils/constant'

export const headerHeight = 40

export const Header = () =>
  match(useAppSelector((state) => state.Ui.headerType))
    .with('Web', () => <WebHeader />)
    .with('App', () => <AppHeader />)
    .otherwise(constant(null))
